import { BondValidationResponse } from '../models/bond-validation.model';
import { SuretyBranch } from './surety-validator.actions';

export interface ISuretyValidatorState {
  bondResult: BondValidationResponse;
  error: any;
  selectedBranch: SuretyBranch;
}

export const initialSuretyValidatorState: ISuretyValidatorState = {
  bondResult: null,
  error: null,
  selectedBranch: 'aserta',
};
